import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { DivisionSelectorComponent } from './division-selector/division-selector.component';
import { DivisionCoreService } from './division-core.service';

@NgModule({
  declarations: [DivisionSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [DivisionCoreService],
  exports: [DivisionSelectorComponent],
})
export class DivisionCoreModule {}
